import { React, useState, useEffect } from "react";
import classes from './RiskQuestion.module.scss';
import RiskOptions from "./RiskOptions";
import Mitigation from "./Mitigation";
import CUSTOM_TAG_EXTRACTOR from "../../../../../Helpers/stringExtractor";

//MUI imports
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FavouriteQuestion from "./FavouriteQuestion"



//MUI Extensions
import Text from "../../../../Shared/Fields/Text"

function RiskQuestion(
    {
        onChosen,
        onPriorityChosen,
        layerIndex, 
        layerChoiceTitle, 
        questionValues,
        priorityQuestions,
        riskOptions, 
        questions,
        showBlurb = true,
        fields, 
        mitigationFields,
        mitigationBody, 
        definitions, 
        layerKey,
        favouriteContent,
        defaultOpen, 
        layerIntro
    }
    ) {

    const [questionScreenValues, setQuestionScreenValues] = useState([]);
    const [inlineDefinitionCopy, setInlineDefinitionCopy] = useState([]);
    const [riskOptionsContent, setRiskOptionsContent] = useState([]);
    const [priorityChoices, setPriorityChoices] = useState([]);
    const [isExpanded, setIsExpanded] = useState(defaultOpen);
    let [layerDefinitions,] = useState({});

    function onFieldUpdate(questionIndex, value, forKey){
        let questionScreenValuesClone = (questionScreenValues !== undefined ? JSON.parse(JSON.stringify(questionScreenValues)) : [])

        if(questionScreenValuesClone[questionIndex] === null || questionScreenValuesClone[questionIndex] === undefined){
            questionScreenValuesClone[questionIndex] = {}
        }

        questionScreenValuesClone[questionIndex][forKey] = value

        //Keep the values up-to-date with the entered text
        setQuestionScreenValues(questionScreenValuesClone);

        //Send whats entered on up the component chain
        onChosen(questionIndex, value, forKey)
    }

    function onPriorityUpdate(questionIndex, value){

        let priorityChoicesClone = JSON.parse(JSON.stringify(priorityChoices))

        if(value){
            priorityChoicesClone.push(questionIndex)
        }else{
            let priorityIndex = priorityChoicesClone.indexOf(questionIndex)
            priorityChoicesClone.splice(priorityIndex, 1)
        }

        setPriorityChoices(priorityChoicesClone)

        //Send whats entered on up the component chain
        onPriorityChosen(questionIndex, priorityChoicesClone, layerKey)
    }

    useEffect(() => {

        layerDefinitions.current = {}
        if(definitions[layerKey] !== undefined){
            layerDefinitions.current[layerKey] = {...definitions[layerKey]}
        }

        if(definitions["multiple"]){
            layerDefinitions.current.multiple = {...definitions["multiple"]}
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[definitions])

    function populateInlineDefinitionToolTips(){

        if(definitions[layerKey]){
            
            let inlineDefinitionCopyClone = JSON.parse(JSON.stringify(inlineDefinitionCopy));

            questions.forEach((element, index) => {

                let extractedTagData = CUSTOM_TAG_EXTRACTOR.SPLIT_DEFINITION_ELEMENTS_FROM_STRING(element.copy, definitions, layerKey)
                let definitionElements = extractedTagData.definitionElemments
                let copyParts = extractedTagData.copyItems
                
                if(extractedTagData){
                    inlineDefinitionCopyClone[index] = CUSTOM_TAG_EXTRACTOR.GENERATE_INLINE_TOOL_TIP_PARAGRAPH(definitionElements,copyParts)
                }else{
                    inlineDefinitionCopyClone[index] = element.copy
                }

            });

            setInlineDefinitionCopy(inlineDefinitionCopyClone)

        }

    }

    useEffect(() => {
        if(questionValues !== undefined){
            if(JSON.stringify(questionValues) !== JSON.stringify(questionScreenValues)){
                setQuestionScreenValues(questionValues)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[questionValues])

    useEffect(() => {
        populateInlineDefinitionToolTips();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[definitions])

    useEffect(() => {
        if(priorityQuestions){
            if(priorityQuestions[layerKey] !== undefined){
                setPriorityChoices([...priorityQuestions[layerKey]])
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[priorityQuestions])

    useEffect(() => {

        let inlineDefinitionCopyClone = JSON.parse(JSON.stringify(inlineDefinitionCopy));

        let questionRiskOptions = []

        questions.forEach((question, index) => {

            let defaultRiskOptionsContentClone = JSON.parse(JSON.stringify(riskOptions.options))

            inlineDefinitionCopyClone[index] = question.copy

            if(question.riskOptionTooltipsOverride !== undefined){
                let targetKeys = Object.keys(question.riskOptionTooltipsOverride)
                targetKeys.forEach(key => {
                    defaultRiskOptionsContentClone[key].defaultToolTip = question.riskOptionTooltipsOverride[key]
                })
            }

            let overiddenRiskOptions = riskOptions.order.map(key => {
                return(defaultRiskOptionsContentClone[key])
            })

            questionRiskOptions.push(overiddenRiskOptions)

        });

        setRiskOptionsContent(questionRiskOptions);
        setInlineDefinitionCopy(inlineDefinitionCopyClone);
        populateInlineDefinitionToolTips();
        setQuestionScreenValues(questions);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[questions])

    function getFieldValue(questionIndex, fieldKey){
        if(questionScreenValues !== undefined){
            if(questionScreenValues[questionIndex] !== undefined && questionScreenValues[questionIndex] !== null){
                if(questionScreenValues[questionIndex][fieldKey] !== undefined){
                    return questionScreenValues[questionIndex][fieldKey]
                }
            }
        }
        return ""
    }

    return (
        <Box className={`${classes.RiskQuestion__accordion_container}`}>
            <Accordion 
                TransitionProps={
                    {
                        onEnter:() => {setIsExpanded(true)},
                        onExited:() => {setIsExpanded(false)}
                    }
                }
                defaultExpanded={(defaultOpen === true ? true : false)}>
                <AccordionSummary className={` content_wrapper__inner`} expandIcon={<ExpandMoreIcon />}>
                    <p className={`redColor accordion_padding`}><strong dangerouslySetInnerHTML={{__html:`${layerIndex+1}) ${layerChoiceTitle}`}} /></p>
                </AccordionSummary>
                {
                    isExpanded
                    ?
                    questions.map((question, questionIndex)=>{

                        return(

                            <div key={questionIndex}>
                                <div className={`gain_content_container ${classes.RiskQuestion__accordion_details_wrapper}`}>
                                    <AccordionDetails className={`gain_content_container__form_container ${classes.RiskQuestion__accordion_details}`}>
                                        <div className={`${classes.RiskQuestion__heading_container} accordion_padding`}>
                                            <strong><p dangerouslySetInnerHTML={{__html:question.heading}}></p></strong>
                                            <p dangerouslySetInnerHTML={{__html:question.subHeading}}></p>
                                        </div>
                                        {(
                                            question.tooltip !== "" || question.links.length > 0 ?
                                            <div className={`${classes.RiskQuestion__question_copy} ${classes.RiskQuestion__question_copy__tt_lk} accordion_padding`}>
                                                
                                                <FavouriteQuestion 
                                                    onPriorityUpdate={onPriorityUpdate}
                                                    priorityChoices={priorityChoices} 
                                                    questionIndex={questionIndex} 
                                                    toolTipCopy={favouriteContent.toolTip}></FavouriteQuestion>
                                                <p>{`${layerIndex+1}.${questionIndex+1})`} {inlineDefinitionCopy[questionIndex]}</p>  
                                                <div className={`${classes.RiskQuestion__question_copy__tt_lk} ${classes.RiskQuestion__question_copy__tt_lk__icons}`}>
                                                    {(
                                                        question.tooltip !== ""?
                                                        
                                                        <Tooltip title={<span dangerouslySetInnerHTML={{__html:question.tooltip}}/>}>
                                                            <HelpOutlineOutlinedIcon
                                                                sx={{
                                                                    height:"21px",
                                                                    width:"21px",
                                                                    marginRight:"5px",
                                                                    paddingTop:"2px",
                                                                }}
                                                            />
                                                        </Tooltip>
                                                        :
                                                        ""
                                                    )}
                                                    {(
                                                        question.links.length > 0?
                                                        question.links.map((link, index) => {
                                                            
                                                            return(

                                                                <a key={index} className={`${classes.RiskQuestion__question_copy__link_icon}`} href={link} target="_blank" rel="noreferrer">
                                                                    <InsertLinkOutlinedIcon
                                                                        sx={{
                                                                            height:"25px",
                                                                            width:"25px"
                                                                        }}
                                                                    />
                                                                </a>

                                                            )

                                                        })
                                                        :
                                                        ""
                                                    )}
                                                </div>
                                            </div>
                                            :
                                            <p className={`${classes.RiskQuestion__question_copy} accordion_padding`} dangerouslySetInnerHTML={{__html:`${layerIndex+1}.${questionIndex+1}) ${question.copy}`}}></p>
                                        )} 
                                        <div className={`${classes.RiskQuestion__risk_options} accordion_padding`}>
                                        <p className={`small_copy`} dangerouslySetInnerHTML={{__html: riskOptions.flag}}></p>
                                            {
                                                riskOptionsContent[questionIndex] !== undefined
                                                ?
                                                    <RiskOptions
                                                    onChosen={onFieldUpdate} 
                                                    layerChoiceTitle={layerChoiceTitle}
                                                    questionIndex={questionIndex}
                                                    questionValues={questionValues}
                                                    riskOptions={riskOptionsContent[questionIndex]}
                                                />
                                                :
                                                ""
                                            }                     
                                        </div>
                                        <div className={`accordion_padding`}>
                                            {fields.map((field, index)=>{
                                                return(
                                                    <Text 
                                                        value={getFieldValue(questionIndex, field.key) || ""}
                                                        key={index}
                                                        field={field}
                                                        label={
                                                            <div className={`${classes.RiskQuestion__text_field_label}`}>
                                                            {field.label}
                                                            {(
                                                                field.tooltip !== ""?
                                                                    <Tooltip title={<span dangerouslySetInnerHTML={{__html:field.tooltip}}/>} className={`${classes.RiskQuestion__tooltip}`}>
                                                                        <InfoOutlinedIcon sx={{
                                                                            height:"20px",
                                                                            width:"20px",
                                                                            marginLeft:"8px"
                                                                        }} 
                                                                        />
                                                                    </Tooltip>
                                                                    :
                                                                    ""
                                                            )}
                                                            </div>
                                                        }
                                                        onChange={(value) =>{onFieldUpdate(questionIndex, value, field.key)}}
                                                        />
                                                )
                                            })}
                                        </div>
                                    </AccordionDetails>
                                    <AccordionDetails className={` accordion_padding gain_content_container__guidance`}>
                                        {(
                                            layerIntro && questionIndex === 0 && showBlurb ? 
                                            <> 
                                                {layerIntro.map((content, index) =>{
                                                    return <div  className={`${classes.RiskQuestion__helper_container}`} key={index}>
                                                        {
                                                        (
                                                        content.subtitle ? 
                                                        <div  className={`subtitle_copy`} dangerouslySetInnerHTML={{__html:content.subtitle}}></div>
                                                        :
                                                        ""
                                                        )
                                                        }
                                                        {
                                                        (
                                                        content.copy ? 
                                                        <div  className={`small_copy`} dangerouslySetInnerHTML={{__html:content.copy}}></div>
                                                        :
                                                        ""
                                                        )
                                                        }
                                                        
                                                    </div>
                                                })}
                                            </>
                                            :
                                            ""
                                        )}
                                    
                                        
                                    </AccordionDetails>    
                                </div>
                                {
                                    questionValues !== undefined
                                    ?
                                        <Mitigation 
                                            
                                            questionValue={questionScreenValues[questionIndex]} 
                                            riskOptions={riskOptions}
                                            toolTipOverrides={question.mitigationActionsToolTipsOverride}
                                            mitigationFields={mitigationFields}
                                            mitigationBody={mitigationBody}
                                            onUpdate={(mitigations) => {onChosen(questionIndex, mitigations, "mitigation")}}
                                            />
                                    :
                                        ""
                                }

                            </div>

                        )

                    })
                    :
                    ""
                }
              
            </Accordion>
        </Box>
    )
                            

}
export default RiskQuestion